import $ from 'jquery';

import layout from '../utils/layout';
import NavMobileSubMenus from './NavMobileSubMenus';
import ScrollLock from '../utils/ScrollLock';

export default class NavMobile {
  constructor(options) {
    this.$body = $(document.body);
    this.$window = $(window);
    this.$el = options.$el;
    this.stickyHeader = options.stickyHeader;
    this.isOpen = false;
    this.subMenus = null;

    this.$mobileNav = this.$el.find('[data-mobile-nav]');
    this.$panel = this.$el.find('[data-mobile-nav-panel]');
    this.$overlay = this.$el.find('[data-mobile-nav-overlay]');
    this.$toggleClose = this.$el.find('[data-mobile-nav-close]');
    this.$tier1Navmenu = this.$el.find('[data-navmenu]').first();

    this.touchStart = null;

    // Revert navigation to original state on breakpoint change
    this.layoutHandler = this.onBreakpointChange.bind(this);
    layout.onBreakpointChange(this.layoutHandler);

    this._bindEvents();

    this.stopProp = (e) => {
      e.stopPropagation();
    };
  }

  unload() {
    this._close();
    this.permanentEvents.forEach($el => $el.off('.mobile-nav'));
    layout.offBreakpointChange(this.layoutHandler);
  }

  onBreakpointChange() {
    if (layout.isBreakpoint('L', 'XL') && this.isOpen) {
      this._close();
    }
  }

  _bindEvents() {
    this.permanentEvents = [
      this.$body.on('touchstart.mobile-nav', event => this._handleTouchStart(event)),
      this.$body.on('touchend.mobile-nav', event => this._handleTouchEnd(event)),
      this.$mobileNav.on('touchmove.mobile-nav', (event) => {
        // prevent scrolling outside of actual nav menu to combat showing/hiding url bar on mobile
        if (this.$tier1Navmenu.find(event.target).length === 0) {
          event.preventDefault();
        }
      }),
    ];
  }

  _handleTouchStart(event) {
    this.touchStart = event.originalEvent.changedTouches[0];
  }

  _handleTouchEnd(event) {
    if (!this.touchStart) {
      return;
    }

    // touch points
    const touchStart = this.touchStart;
    const touchEnd = event.originalEvent.changedTouches[0];

    // touch stroke differentials
    const dX = touchStart.clientX - touchEnd.clientX;
    const dY = Math.abs(touchStart.clientY - touchEnd.clientY);

    // sensitivities
    const angleThreshold = 0.25;
    const edgeThreshold = 10;
    const minSwipeLength = 75;

    if (dX > minSwipeLength && dY / dX < angleThreshold) {
      this._close();
    } else if (
      dX < -minSwipeLength
        && dY / dX < angleThreshold
        && touchStart.clientX < edgeThreshold
    ) {
      this.open();
    }

    this.touchStart = null;
  }

  open() {
    if (this.isOpen) {
      return;
    }

    this.$el.on('touchmove', this.stopProp);
    ScrollLock.lock();

    // position mobile nav at scrolled position on page
    this.$mobileNav.css({
      left: `${Math.floor(window.scrollX)}px`,
      height: `${window.innerHeight}px`,
    });

    this.isOpen = true;

    // Activate Submenu handler
    this.subMenus = new NavMobileSubMenus(this.$panel);

    // Animate in elements
    // Each of these elements has an animation-delay applied so that they are triggered in sequence.
    this.$mobileNav.addClass('visible');
    $('.mobile-nav-overlay', this.$mobileNav).addClass('animating-in')
      .one('animationend', (e) => {
        e.target.classList.remove('animating-in');
      });

    $('.site-mobile-nav', this.$mobileNav).addClass('animating-in open')
      .one('animationend', (e) => {
        e.target.classList.remove('animating-in');

        // Add Event handlers after the animation is complete
        this.events = [
          // Close menu when clicking on the overlay
          this.$overlay.on('click.mobile-nav', event => this._close(event)),
          this.$toggleClose.on('click.mobile-nav', event => this._close(event)),
          $(window).on('resize.mobile-nav', () => {
            this.$body.css({ height: `${window.innerHeight}px` });
            this.$mobileNav.css({ height: `${window.innerHeight}px` });
          }),
        ];
      });

    const delayIncrement = 350 / $('.navmenu.navmenu-depth-1 > .navmenu-item', this.$mobileNav).length;
    $('.navmenu.navmenu-depth-1 > .navmenu-item', this.$mobileNav).each((i, e1) => {
      const $delay = (i * delayIncrement) + 150;
      $(e1).css({ 'animation-delay': `${$delay}ms` });
      $(e1).on('animationend', e2 => e2.stopPropagation());
    });
  }

  _close(event = false) {
    if (!this.isOpen) {
      return;
    }

    if (event) event.preventDefault();

    // Animate out elements
    // All of the following elements have an animation delay to follow in sequence after the last.
    $('.site-mobile-nav, .mobile-nav-overlay').addClass('animating-out')
      .one('animationend', (e) => {
        e.stopPropagation();
        e.target.classList.remove('animating-out');
        e.target.classList.remove('open');
        // when mobile-nav-overlay is done animating (last in sequence),
        // remove visible class from parent
        if (e.target.classList.contains('mobile-nav-overlay')) {
          this.$mobileNav.removeClass('visible');
        }
      });

    this.$el.off('touchmove', this.stopProp);
    ScrollLock.unlock();

    this.isOpen = false;

    // Close any open drop down menus
    if (this.subMenus) {
      this.subMenus.closeSubMenus(this.$el);
      this.subMenus.closeAllSubmenus();

      // Unbind Mobile sub menus
      this.subMenus.unload();
    }

    // Unbind events
    if (this.events) {
      this.events.forEach($el => $el.off('.mobile-nav'));
      this.events = [];
    }
  }
}
